/** Etichette canoniche delle zone corporee (body-map fastidi + infortuni).
 *  Fonte UNICA di verità — allineata al mobile (apps/mobile/enums/bodyMap.ts) per coerenza
 *  atleta↔coach (bug 8680d4). Keyed per VALORE zona (es. 'quadricep_dx'). */
export const BODY_ZONE_LABELS: Record<string, string> = {
  head_neck: 'Testa / Collo',
  shoulder_dx: 'Spalla Dx', shoulder_sx: 'Spalla Sx',
  chest_ribs: 'Petto / Costole',
  elbow_dx: 'Gomito Dx', elbow_sx: 'Gomito Sx',
  wrist_hand_dx: 'Polso / Mano Dx', wrist_hand_sx: 'Polso / Mano Sx',
  quadricep_dx: 'Quadricipite Dx', quadricep_sx: 'Quadricipite Sx',
  knee_dx: 'Ginocchio Dx', knee_sx: 'Ginocchio Sx',
  upper_back: 'Schiena Alta',
  lumbar: 'Lombare',
  hip_groin_dx: 'Anca / Inguine Dx', hip_groin_sx: 'Anca / Inguine Sx',
  hamstring_dx: 'Ischiotibiali Dx', hamstring_sx: 'Ischiotibiali Sx',
  calf_dx: 'Polpaccio Dx', calf_sx: 'Polpaccio Sx',
  ankle_foot_dx: 'Caviglia / Piede Dx', ankle_foot_sx: 'Caviglia / Piede Sx',
};

/** Helper: label per una zona (fallback al valore grezzo se ignota). */
export const bodyZoneLabel = (zone: string): string => BODY_ZONE_LABELS[zone] ?? zone;
